import { withSvgIcon } from './withSvgIcon';

export const Minimize = withSvgIcon(
  <>
    <path
      d="M10 20V14H4"
      stroke="currentColor"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path
      d="M14 4L14 10L20 10"
      stroke="currentColor"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
